var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.68,
    height: 31.4,
    viewBox: "0 0 41.68 31.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(-1180.768 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(490.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(690.057 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box-fragile-svgrepo-com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M39.636,51.307H2.045A1.991,1.991,0,0,0,0,53.234V80.78a1.991,1.991,0,0,0,2.045,1.927H39.636A1.991,1.991,0,0,0,41.68,80.78V53.234A1.991,1.991,0,0,0,39.636,51.307Zm.74,29.473a.72.72,0,0,1-.74.7H2.045a.72.72,0,0,1-.74-.7V53.234a.72.72,0,0,1,.74-.7H39.636a.72.72,0,0,1,.74.7V80.78Z",
    transform: "translate(0 -51.307)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "window-actions",
    d: "M7.107,13.574a.919.919,0,1,1,.919.917.919.919,0,0,1-.919-.917Zm2.6,0a.919.919,0,1,1,.918.917.919.919,0,0,1-.918-.917Zm2.6,0a.918.918,0,1,1,.917.917.918.918,0,0,1-.917-.917Z",
    transform: "translate(1177.874 375.595)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(104.533 255.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trackbar",
    transform: "translate(1073.403 119.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line",
    d: "M7.895,33.674a.533.533,0,0,1,.531-.531H39.767a.532.532,0,0,1,0,1.064H8.426A.532.532,0,0,1,7.895,33.674Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "position",
    d: "M12.778,31.39a2.153,2.153,0,1,1-2.153,2.153,2.153,2.153,0,0,1,2.153-2.153Z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "play",
    d: "M28.711,24.381l-7.028,4.061c-.582.336-1.056.063-1.056-.609v-8.12c0-.672.474-.945,1.055-.609l7.03,4.059a.643.643,0,0,1,0,1.218Z",
    transform: "translate(1073.403 119.04)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayback);
export default __webpack_public_path__ + "static/media/playback.e27f9f087e4fdb88345f56aff19934fd.svg";
export { ForwardRef as ReactComponent };